import { useRef } from 'react';
import { bookingImage } from '@/mocks/home';
import { useMotion } from '@/hooks/useEditorialMotion';
import BookButton from '@/pages/home/components/BookButton';

export default function Booking() {
  const ref = useRef<HTMLElement>(null);
  useMotion(ref);
  return (
    <section ref={ref} id="book" className="bg-background-50 py-16 md:py-28">
      <div data-group className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-10 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1 lg:pr-10">
          <div data-m="left-lg">
            <h2 className="font-heading font-semibold tracking-[-0.02em] leading-[1.05] text-[36px] md:text-[56px] text-foreground-950">Book an Appointment</h2>
            <p className="mt-6 text-[16px] leading-relaxed text-foreground-700 max-w-md">Choose your service, stylist and time online. New clients start with a short consultation so we can plan the right result.</p>
          </div>
          <div data-m="btn" data-at="0.3" className="mt-8"><BookButton /></div>
        </div>
        <div data-m="clip" className="lg:col-span-6 order-1 lg:order-2 w-full aspect-[4/5] sm:aspect-[6/7] overflow-hidden">
          <img data-m="zoom" src={bookingImage} width={1000} height={1167} loading="lazy" decoding="async" alt="Polished blonde chignon in side profile" title="Styling at NOVA Hair Studio" className="w-full h-full object-cover object-top" />
        </div>
      </div>
    </section>
  );
}